import React, { useState } from 'react';
import { CSSTransition } from "react-transition-group";
import { ReactComponent as BtnIcon16 } from "../lib/icons/Target16.svg";
import { ReactComponent as BtnIcon24 } from "../lib/icons/Target24.svg";
import { ReactComponent as Gear } from "../lib/icons/gear.svg";
import '../lib/index.css';
import { useAppDispatch, useAppSelector } from '../../../../../shared/hooks/useReduxHooks';
import { focusedTaskSlice } from '../../../model/focus-task.slice';
import { Button } from '../../../../../shared/ui/Button';
import useOutside from '../../../../../shared/hooks/useOutside';
import ToolTipComponent from '../../../../../shared/ui/Tooltips/Tooltip';
import { useFocusInfo } from '../../../lib/hooks/useFocusInfo';
import { changeFocusVariant } from '../../../api/changeFocusVariant';

export default function FocusTaskBtn() {
    const dispatch = useAppDispatch();
    const focusIsOpen = useAppSelector(focusedTaskSlice.selectors.getFocusTask);
    const focusViewVariant = useAppSelector(focusedTaskSlice.selectors.getVariantView);
    const { getTooltipData } = useFocusInfo();
    const [settingsIsOpen, setSettingsIsOpen] = useState(false);
    const onCloseRef = useOutside(() => setSettingsIsOpen(false));

    function btnHandler() {
        dispatch(focusedTaskSlice.actions.actionFocus({isOpen: !focusIsOpen}))
    }

    function changeView(payload: 0 | 1) {
        dispatch(changeFocusVariant(payload))
    }
    
    const stylesList = {
        width: 'max-content',
        maxWidth: '297px',
        minWidth: '257px',
        backgroundColor: 'rgba(172, 152, 246, 1)',
        top: '140%',
        right: '-35%'
      }

    const stylesListArrow = {
        top: '-7%',
        right: '25%'
      }

    const btnElement = <button className={`focus-task-btn ${focusIsOpen && `focused`}`} disabled={getTooltipData.isDisabled && !focusIsOpen} onClick={() => btnHandler()}>
                            <BtnIcon16 className='focus-task-icon'/>
                            <p className='focus-task-label'>{focusIsOpen ? 'Выйти из фокуса' : 'Фокус'}</p>
                        </button>
    
    const tooltipContent = <div>
       <p style={{fontSize: '12px', marginBottom: '6px'}}>Сфокусируйся на главном</p>
        <div style={{fontSize: '12px', fontWeight: 400, display: 'flex', flexDirection: 'column', gap: '12px'}}>
            {getTooltipData.description && <p>{getTooltipData.description}</p>}
            {getTooltipData.subDescription && <p>{getTooltipData.subDescription}</p>}
        </div>
    </div>

    return (
        <div className={`focus-task-container ${focusIsOpen && `focused`}`}>
            <ToolTipComponent  
                stylesList={stylesList} 
                stylesListArrow={stylesListArrow} 
                active={getTooltipData.isDisabled && !focusIsOpen}
                children={btnElement}
                tooltipComponent={tooltipContent}
                />
            {
                focusIsOpen &&
                <div ref={onCloseRef} style={{display: 'flex', flexDirection: 'column', justifyContent: 'center'}}>
                    <button className='focus-task-settings' onClick={() => setSettingsIsOpen(!settingsIsOpen)}>
                        <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center'}}>
                            <Gear className='focus-task-settings__icon' />
                        </div>
                    </button>
                    <CSSTransition
                        in={settingsIsOpen}
                        classNames='menus-animation-tmp'
                        timeout={200}
                        unmountOnExit>
                        <div className='focus-settings-popover'>        
                            {
                                settingsIsOpen &&
                                <div className='focus-settings-popover__container' >
                                    <div className='focus-settings-popover__heading'>
                                        <div>
                                            <BtnIcon24 />
                                        </div>
                                        <h2>Настройки фокуса</h2>
                                    </div>
                                    <div className='focus-settings-popover__description'>
                                        <div className='focus-settings-popover__view-settings'>
                                            <h3 className='focus-settings-popover__view-settings__header'>Отображение</h3>
                                            <p className='focus-settings-popover__view-settings__description'>Задачи с другими приоритетами</p>
                                            <div className='focus-settings-popover__view-settings__btn-group'>
                                                <Button btnType={focusViewVariant === 0 ? 'filled' : 'default'} title='Затемнить' btnSize='xs' onClickFunc={() => changeView(0)} />
                                                <Button btnType={focusViewVariant === 1 ? 'filled' : 'default'} title='Скрыть' btnSize='xs' onClickFunc={() => changeView(1)} />
                                            </div>
                                        </div>
                                        <p className='focus-settings-popover__description-content'>Когда все задачи приоритета выполнены, фокус автоматически переходит к следующему</p>
                                    </div>
                                </div>
                            }
                        </div>
                    </CSSTransition>
                </div>
            }
        </div>
    )
}